import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/logo-updated.svg'
import _imports_1 from '../../assets/logo-updated-blue.svg'


const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = {
  key: 0,
  class: "img-fluid",
  src: _imports_0,
  alt: "IntelligentRx Logo"
}
const _hoisted_3 = {
  key: 1,
  class: "img-fluid",
  src: _imports_1,
  alt: "IntelligentRx Logo"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (($options.noSearchInHeader && !$props.pinHeader) || $data.showSearchBar || !$options.noSearchInHeader || ($props.pinHeader && $data.showMobileSearchBarNoNavInfo))
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: _normalizeClass(["navbar fixed-top navbar-expand-lg navbar-light navbar-overall", $options.getHeaderClass])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            class: "navbar-brand",
            to: "/"
          }, {
            default: _withCtx(() => [
              ($options.darkBackground && !$props.pinHeader && (($options.noSearchInHeader && !$props.pinHeader) || $data.showSearchBar || !$options.noSearchInHeader))
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : ((($options.noSearchInHeader && !$props.pinHeader) || $data.showSearchBar || !$options.noSearchInHeader))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: _normalizeClass(["navbar-toggler ml-auto", $options.getToggleNavColorClass]),
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#navbarSupportedContent",
            "aria-controls": "navbarSupportedContent",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
          ]))], 2),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "collapse navbar-collapse justify-content-end",
            id: "navbarSupportedContent"
          }, [
            _createElementVNode("ul", { class: "navbar-nav" }, [
              _createElementVNode("li", { class: "nav-item" })
            ])
          ], -1))
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4))
}